import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faSquareGithub } from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faSquarePhoneFlip } from "@fortawesome/free-solid-svg-icons";
import Cv from "../../img/cv.pdf";

export default function ContactDesk() {
  return (
    <div className="contactMe">
      <div className="container-icons">
        <p>
          <Link to={"mailto:tonadresse@email.com"}>
            <FontAwesomeIcon icon={faPaperPlane} />
          </Link>
        </p>
        <p className="numberIcon">
          <span>0619335681</span>
          <Link>
            <FontAwesomeIcon icon={faSquarePhoneFlip} />
          </Link>
        </p>

        <p>
          <Link
            target="_blank"
            to={"https://www.linkedin.com/in/faouaz-abdallah-638099191/"}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </Link>
        </p>
        <p>
          <Link target="_blank" to={"https://github.com/GitHubFaouaz"}>
            <FontAwesomeIcon icon={faSquareGithub} />
          </Link>
        </p>

        <Link to={Cv} target="_blank">
          <button className="btnCv">C V</button>
        </Link>
      </div>
    </div>
  );
}
